import { formatMoney } from 'accounting'

import { Box, Form, Text } from '@domain-group/suit-theme'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons'

interface TaskPriceProps {
  taskPrice?: number,
}

const TaskPrice = (props: TaskPriceProps) => {
  const { taskPrice } = props

  if (!taskPrice || taskPrice <= 0) return null

  return (
    <Form.Field label="Task Cost" marginTop="large">
      <Box padding="large" variant="whiteGrey">
        <Text color="orange" fontSize="small">
          <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: 8 }} />
          Additional cost of {formatMoney(taskPrice)} for this task.
        </Text>
      </Box>
    </Form.Field>
  )
}

export default TaskPrice
